import React, {Component} from 'react';
import {Button, Checkbox, Form, Message, Modal, TextArea} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization} from "../utils/localization";
import {COVERAGE_DECLINED_PATH, languages} from "../utils/common";
import {CustomModalHeader} from "./custom-common";
import {DeclineCoverageRequest} from "../services/types";
import {declineCoverage} from "../services/services";


const mapStateToProps = (state, ownProps) => {
    const {initialData: {declineReasons, token}, user: {lang}} = state;

    return {
        declineReasons,
        token,
        lang,
        ...ownProps
    }
};

class IDontWantCoverageModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            submitError: '',
            explanation: "",
            selectedDeclineReasons: [],
        }
    }

    handleSubmit = async () => {
        const localization = getLocalization(this.props.lang);
        const strings = localization.declineCoverageModal;
        const {explanation, selectedDeclineReasons} = this.state;
        this.setState({loading: true, submitError: null});
        try {
            const payload = new DeclineCoverageRequest ({
                reasons: selectedDeclineReasons,
                explanation: explanation,
                token: this.props.token,
            });
            await declineCoverage(payload);
            this.setState({loading: false});
            this.props.onModalClose();
            window.onbeforeunload = null;
            this.props.history.push(COVERAGE_DECLINED_PATH);
        } catch (e) {
            this.setState({loading: false, submitError: strings.err});
        }
    }

    render() {
        const {opened, onModalClose, declineReasons, lang} = this.props;
        const {explanation, loading, submitError, selectedDeclineReasons} = this.state;
        const localization = getLocalization(lang);
        const strings = localization.declineCoverageModal;
        const localizationEng = getLocalization(languages.ENGLISH);
        const engStrings = localizationEng.declineCoverageModal;

        return (
            <Modal size={'tiny'} onClose={onModalClose} open={opened}>
                <CustomModalHeader title={strings.title} onClose={onModalClose}/>
                <Modal.Content style={{maxHeight: '513px', overflowY: 'auto'}} className={"small"}>
                    <p>{strings.subTitle}</p>

                    <Form>
                        <Form.Field>
                            <label style={{marginBottom: '0.5em'}}>{strings.reasons}</label>
                            {declineReasons.map((dr) => {
                                let text = dr.text;
                                if (text === engStrings.itsToo) {
                                    text = strings.itsToo;
                                } else if (text === engStrings.iDontThink) {
                                    text = strings.iDontThink;
                                } else if (text === engStrings.iDontUnderstand) {
                                    text = strings.iDontUnderstand;
                                }

                                const handleOnChange = () => {
                                    if (text === strings.itsToo) {
                                        text = engStrings.itsToo;
                                    } else if (text === strings.iDontThink) {
                                        text = engStrings.iDontThink;
                                    } else if (text === strings.iDontUnderstand) {
                                        text = engStrings.iDontUnderstand;
                                    }

                                    const exists = selectedDeclineReasons.filter(s => s === text);
                                    let newSelectedDeclineReasons;
                                    if (!!exists && exists.length > 0) {
                                        newSelectedDeclineReasons = selectedDeclineReasons.filter(s => s !== text);
                                    } else {
                                        newSelectedDeclineReasons = selectedDeclineReasons;
                                        newSelectedDeclineReasons.push(text);
                                    }
                                    this.setState({
                                        selectedDeclineReasons: [...newSelectedDeclineReasons]
                                    })
                                };

                                return <React.Fragment key={dr.key}>
                                    <Checkbox style={{marginBottom: '0.5em'}} label={text} onChange={handleOnChange}/>
                                    <br/>
                                </React.Fragment>
                            })}
                        </Form.Field>

                        <Form.Field>
                            <label style={{marginBottom: '0.5em'}}>{strings.explanation} <span style={{fontWeight: 'normal'}}>{strings.optional}</span></label>
                            <TextArea value={explanation}
                                      placeholder={strings.tellUsMore}
                                      onChange={(e, {value})=> this.setState({explanation: value})}/>
                        </Form.Field>

                        {!!submitError && <div><Message negative style={{margin: '0.8em'}}>{submitError}</Message></div>}

                        <div style={{textAlign: 'right'}}>
                            <Button className={'emptyButton'} onClick={onModalClose}>{strings.cancel}</Button>
                            <Button primary
                                    disabled={ selectedDeclineReasons.length === 0 }
                                    loading={loading}
                                    onClick={this.handleSubmit}>{strings.submit}</Button>
                        </div>
                    </Form>
                </Modal.Content>
            </Modal>
        );
    }
}

export default withRouter(connect(mapStateToProps)(IDontWantCoverageModal));
